import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { isSuperAdmin } from "../utils/roleUtils";

export default function AdminGate({ children }) {
  const { currentUser, userProfile, loading } = useAuth();

  if (loading) {
    return (
      <div className="admin-gate-loading">
        <p>Loading admin access…</p>
      </div>
    );
  }

  if (!currentUser || !isSuperAdmin(userProfile)) {
    return <Navigate to="/" replace />;
  }

  return children;
}
